let qaBlock = `
...on qabuilder_questionAnswer_BlockType {
  id
  typeHandle
  copy
  body
}`

let bookEntryFields = `
  id
  slug
  title
  sectionHandle
  ...on chapteredPage_Entry {
    qabuilder {
      ...on qabuilder_questionSection_BlockType {
        id
        typeHandle
        heading
        children {
          ...on qabuilder_questionSection_BlockType {
            id
            typeHandle
            heading
            children {
              ${qaBlock}
            }
          }
          ${qaBlock}
        }
      }
    }
  }
`

export const page = `query($slug:[String]) {
  requested: entries(section: "book", slug: $slug, limit: 1) {
    ${bookEntryFields}
  }
  fallback: entries(section: "book", limit: 1) {
    ${bookEntryFields}
  }
}`
